export default "__VITE_PUBLIC_ASSET__c535923b__"